module.exports = "/assets/site/images/evezes.jpg?8f2cbff16ba65395e41285fab52873cd";